<template>
  <v-container id="login" class="fill-height justify-center" tag="section">
    <v-row justify="center">
      <v-slide-y-transition appear>
        <v-card light max-width="100%" width="400" class="px-5 py-3 overflow-visible">
          <div class="d-flex justify-center mb-3 mt-3">
            <v-img max-width="150" src="@/assets/logo.png" />
          </div>
          <base-material-alert v-if="errorMessage" color="warning" dark class="mb-0 mt-2">
            <span class="text-uppercase" v-text="errorMessage"></span>
          </base-material-alert>
          <validation-observer ref="validator" v-slot="{ handleSubmit }">
            <v-card-text class="text-center">
              <validation-provider v-slot="{ errors }" rules="required" name="Tên đăng nhập">
                <v-text-field
                  v-model="username"
                  color="secondary"
                  label="Tên đăng nhập..."
                  prepend-icon="mdi-face"
                  placeholder="Tên đăng nhập"
                  class="mt-2"
                  :error-messages="errors"
                  @keyup.enter="handleSubmit(login)"
                  outlined
                  :autofocus="true"
                />
              </validation-provider>
              <validation-provider v-slot="{ errors }" rules="required" name="Mật khẩu">
                <v-text-field
                  v-model="password"
                  class="mb-2"
                  color="secondary"
                  label="Mật khẩu..."
                  placeholder="Mật khẩu"
                  prepend-icon="mdi-lock-outline"
                  :error-messages="errors"
                  outlined
                  @keyup.enter="handleSubmit(login)"
                  :append-icon="visibleConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="() => (visibleConfirmPassword = !visibleConfirmPassword)"
                  :type="visibleConfirmPassword ? 'password' : 'text'"
                />
              </validation-provider>
              <v-btn color="" class="v-btn--text success--text" @click="handleSubmit(login)">
                Đăng nhập
              </v-btn>
            </v-card-text>
          </validation-observer>
        </v-card>
      </v-slide-y-transition>
    </v-row>
  </v-container>
</template>

<script>
import checkPermission from '@/modules/student_care/mixins/checkPermission';
import { mapActions } from 'vuex';
import { authService } from '@/services/AuthService';
import _ from 'lodash';
import store from '@/store';
import UserRepository from '@/services/UserRepository';
import { permissionCheckMenuBlended, permissionCheckMenuBlendedSecondary } from '../blended/const';

export default {
  name: 'Login',
  $_veeValidate: {
    validator: 'new',
  },
  mixins: [checkPermission],
  data() {
    return {
      username: null,
      password: null,
      errorMessage: '',
      visibleConfirmPassword: true,
    };
  },
  methods: {
    ...mapActions('login', ['loginUser', 'getUserProfile']),
    async login() {
      const valid = this.$refs.validator.validate();
      const loader = this.$loading.show();
      if (valid) {
        const response = await this.loginUser({
          username: this.username,
          password: this.password,
        });
        if (response !== '') {
          this.errorMessage = response;
        } else {
          // await this.getUserProfile();.
          const profile = await authService.getProfile();
          const resGetTypeCurriculum = await UserRepository.getTypeCurriculum();
          const typeCurriculum = _.get(resGetTypeCurriculum, 'data.typeCurriculum', '');
          const permissions = _.get(profile, 'data.role.permissions', []).map((p) => `${p.model}_${p.action}`);
          store.dispatch('SET_PERMISSION', permissions);
          if (typeCurriculum.includes('online') && (this.checkPermission('tutor-homeroom-teacher_read') || this.checkPermission('care-sale_read'))) {
            this.$router.push({
              name: 'StudentCare',
              query: {
                typeCurriculum: 'online',
                tutorSchoolLevel: 'primary',
              },
            });
          } else if (typeCurriculum.includes('online') && (this.checkPermission('tutor-homeroom-teacher-secondary_read') || this.checkPermission('care-sale-secondary_read'))) {
            this.$router.push({
              name: 'StudentCare',
              query: {
                typeCurriculum: 'online',
                tutorSchoolLevel: 'secondary',
              },
            });
          } else if (typeCurriculum.includes('ieltsy') && (this.checkPermission('tutor-homeroom-teacher-ieltsy_read') || this.checkPermission('care-sale-ieltsy_read'))) {
            this.$router.push({
              name: 'StudentCare',
              query: {
                typeCurriculum: 'ieltsy',
              },
            });
          } else if (typeCurriculum.includes('duo') && (this.checkPermission('periodic-care-tab_read') || this.checkPermission('extend-tab_read') || this.checkPermission('general-tab_read'))) {
            this.$router.push({
              name: 'DuoCareList',
              query: {
                typeCurriculum: 'duo',
              },
            });
          } else if (permissionCheckMenuBlended.some((permission) => this.checkPermission(permission))) {
            this.$router.push({
              name: 'StudentList',
              query: {
                typeCurriculum: 'online',
                schoolLevel: 'primary',
              },
            });
            loader.hide();
            return;
          } else if (permissionCheckMenuBlendedSecondary.some((permission) => this.checkPermission(permission))) {
            this.$router.push({
              name: 'StudentList',
              query: {
                typeCurriculum: 'online',
                schoolLevel: 'secondary',
              },
            });
            loader.hide();
            return;
          } else {
            this.$router.push(
              {
                name: 'Error403',
              },
            );
            loader.hide();
          }
        }
      }
      loader.hide();
    },
  },
};
</script>
